<script setup lang="ts">
import { RouterView } from 'vue-router'
import { computed, onMounted } from 'vue'
import { useAppStore } from '@/stores/app.store'
import ModalBase from '@/components/modal/ModalBase.vue'
import DropZone from '@/components/DropZone.vue'
import { useModalStore } from '@/stores/modal.store.ts'
import AnimationShow from '@/components/animation/AnimationShow.vue'

// stores
const { initTheme } = useAppStore()
const appStore = useAppStore()
const modalStore = useModalStore()
const { closeModal } = useModalStore()

// computed
const showBg = computed(() => !appStore.hideBackground)
const showModal = computed(() => modalStore.show)

// lifecycle
onMounted(() => {
  initTheme()
})
</script>

<template>
  <div
    v-if="showBg"
    class="bg-tile isolate min-h-screen bg-stone-200 dark:bg-stone-900 text-stone-900 dark:text-white transition-colors duration-150"
  >
    <div
      class="absolute inset-x-0 left-1/2 -translate-x-1/2 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]"
    >
      <svg
        class="relative left-[calc(50%-11rem)] -z-10 h-[21.1875rem] max-w-none -translate-x-1/2 rotate-[30deg] sm:left-[calc(50%-30rem)] sm:h-[42.375rem]"
        viewBox="0 0 1155 678"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="url(#45de2b6b-92d5-4d68-a6a0-9b9b2abad533)"
          fill-opacity=".3"
          d="M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z"
        />
        <defs>
          <linearGradient
            id="45de2b6b-92d5-4d68-a6a0-9b9b2abad533"
            x1="1155.49"
            x2="-78.208"
            y1=".177"
            y2="474.645"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#3b82f6" offset="0" />
            <stop offset="1" stop-color="#06b6d4" />
          </linearGradient>
        </defs>
      </svg>
    </div>

    <RouterView />
  </div>

  <div v-else>
    <RouterView />
  </div>

  <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div @click="closeModal" class="fixed inset-0 bg-black/50 backdrop-blur-sm"></div>
  </div>

  <animation-show
    :show="showModal"
    custom-class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-md transition-all duration-150 z-50"
  >
    <modal-base></modal-base>
  </animation-show>

  <drop-zone></drop-zone>
</template>

<style scoped></style>
